<template>
    <div class="scoreData" v-if="!isLoading">
        <div class="scoreData__sell">
            <div class="scoreData__sell--header">
                <div class="scoreData__sell--header-title">Score do Vendedor</div>
                <div class="scoreData__sell--header-value" :style="{ color: dynamicColor }">{{sellerScore}}</div>
            </div>
            <div class=" scoreData__sell--content">
                    <NewProgressBar :type="'SellerScore'" :valor="sellerScore" />
                </div>
                <div class="scoreData__sell--footer">
                    <div class="scoreData__sell--footer-title">
                        Vendedor ID:
                    </div>
                    <div class="scoreData__sell--footer-value">
                        {{ sellerId }}
                    </div>
                </div>
            </div>
            <div class="actions">
                <div class="actions__header">
                    <div class="actions__header--icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
                            <path
                                d="M7.59185 1.08765C7.49583 1.03029 7.38607 1 7.27422 1C7.16237 1 7.05261 1.03029 6.95658 1.08765C6.87718 1.15056 6.82361 1.24041 6.806 1.34017C6.78839 1.43993 6.80798 1.54269 6.86106 1.62898C8.81462 5.0091 9.22698 9.61517 6.55855 12.1546C5.53287 11.2923 4.71859 10.2062 4.1783 8.9799C3.19189 9.5277 2.37435 10.3352 1.8144 11.3148C1.25445 12.2943 0.973479 13.4085 1.00197 14.5365C1.04235 15.531 1.28122 16.5073 1.70453 17.4081C2.12783 18.3089 2.72702 19.1159 3.46684 19.7817C4.20667 20.4475 5.07217 20.9586 6.01245 21.285C6.95272 21.6113 7.94877 21.7463 8.94199 21.682C14.0544 21.682 16.7069 18.5073 16.8804 14.5365C17.0874 9.77279 13.7057 3.91371 7.59185 1.08765Z"
                                stroke="#44A561" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                    <div class="actions__header--title">Açōes</div>
                </div>
                <div class="actions__content">
                    <div class="actions__content--item" @click="sellerDetails()">
                        <div class="actions__content--item-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path
                                    d="M0 7.59568H3.48679C3.6336 7.59399 3.77733 7.5533 3.90323 7.47775C4.02912 7.40222 4.13268 7.29456 4.20326 7.1658L7.06911 1.43409C7.13974 1.29138 7.25235 1.17371 7.39181 1.09687C7.53127 1.02002 7.69089 0.987697 7.84926 1.00421C8.007 1.01488 8.15755 1.0742 8.28016 1.17399C8.40279 1.27381 8.49142 1.40917 8.53389 1.56146L12.0844 13.3751C12.131 13.5355 12.2267 13.677 12.3581 13.7798C12.4896 13.8827 12.65 13.9416 12.8168 13.9483C12.973 13.9432 13.1243 13.8921 13.2517 13.8015C13.3791 13.7109 13.477 13.5848 13.5332 13.4388L15.7144 8.10517C15.7745 7.95555 15.8778 7.82721 16.0111 7.73647C16.1443 7.64574 16.3015 7.59673 16.4628 7.59568H20.6979"
                                    stroke="#44A561" stroke-width="1.7" />
                            </svg>
                        </div>
                        <div class="actions__content--item-text">
                            Detalhes
                        </div>
                    </div>
                    <div v-if="value" class="actions__content--item" @click="deactivateUser(value)">
                        <div class="actions__content--item-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23"
                                fill="none">
                                <path
                                    d="M1 10.5529H0.15H1ZM2.59214 21.6979V22.5479V21.6979ZM15.3293 21.6979V22.5479V21.6979ZM16.9214 10.5529H17.7714H16.9214ZM13.6832 8.96071C13.6832 9.43016 14.0638 9.81071 14.5332 9.81071C15.0027 9.81071 15.3832 9.43016 15.3832 8.96071H13.6832ZM8.96071 1V0.15V1ZM3.38821 6.5725H2.53821H3.38821ZM2.53821 8.96071C2.53821 9.43016 2.91877 9.81071 3.38821 9.81071C3.85766 9.81071 4.23821 9.43016 4.23821 8.96071H2.53821ZM9.75679 15.3293H10.6068H9.75679ZM8.96071 14.5332V13.6832V14.5332ZM15.3293 8.11071H2.59214V9.81071H15.3293V8.11071ZM2.59214 8.11071C1.94445 8.11071 1.32328 8.36801 0.865287 8.826L2.06737 10.0281C2.20655 9.8889 2.39531 9.81071 2.59214 9.81071V8.11071ZM0.865287 8.826C0.407297 9.28399 0.15 9.90516 0.15 10.5529H1.85C1.85 10.356 1.92819 10.1673 2.06737 10.0281L0.865287 8.826ZM0.15 10.5529V20.1057H1.85V10.5529H0.15ZM0.15 20.1057C0.15 20.7534 0.407296 21.3746 0.865287 21.8326L2.06737 20.6305C1.92819 20.4913 1.85 20.3025 1.85 20.1057H0.15ZM0.865287 21.8326C1.32328 22.2906 1.94445 22.5479 2.59214 22.5479V20.8479C2.39531 20.8479 2.20655 20.7697 2.06737 20.6305L0.865287 21.8326ZM2.59214 22.5479H15.3293V20.8479H2.59214V22.5479ZM15.3293 22.5479C15.977 22.5479 16.5982 22.2906 17.0561 21.8326L15.8541 20.6305C15.7149 20.7697 15.5261 20.8479 15.3293 20.8479V22.5479ZM17.0561 21.8326C17.5141 21.3746 17.7714 20.7534 17.7714 20.1057H16.0714C16.0714 20.3025 15.9932 20.4913 15.8541 20.6305L17.0561 21.8326ZM17.7714 20.1057V10.5529H16.0714V20.1057H17.7714ZM17.7714 10.5529C17.7714 9.90516 17.5141 9.28399 17.0561 8.826L15.8541 10.0281C15.9932 10.1673 16.0714 10.356 16.0714 10.5529H17.7714ZM17.0561 8.826C16.5982 8.36801 15.977 8.11071 15.3293 8.11071V9.81071C15.5261 9.81071 15.7149 9.8889 15.8541 10.0281L17.0561 8.826ZM15.3832 8.96071V6.5725H13.6832V8.96071H15.3832ZM15.3832 6.5725C15.3832 4.86915 14.7066 3.23556 13.5021 2.03111L12.3 3.23319C13.1857 4.11883 13.6832 5.32001 13.6832 6.5725H15.3832ZM13.5021 2.03111C12.2977 0.826654 10.6641 0.15 8.96071 0.15V1.85C10.2132 1.85 11.4144 2.34755 12.3 3.23319L13.5021 2.03111ZM8.96071 0.15C7.25736 0.15 5.62377 0.826654 4.41932 2.03111L5.6214 3.23319C6.50704 2.34755 7.70823 1.85 8.96071 1.85V0.15ZM4.41932 2.03111C3.21487 3.23556 2.53821 4.86915 2.53821 6.5725H4.23821C4.23821 5.32001 4.73576 4.11883 5.6214 3.23319L4.41932 2.03111ZM2.53821 6.5725V8.96071H4.23821V6.5725H2.53821ZM8.96071 16.9754C9.39728 16.9754 9.81596 16.8019 10.1247 16.4932L8.92258 15.2912C8.9327 15.281 8.94641 15.2754 8.96071 15.2754V16.9754ZM10.1247 16.4932C10.4334 16.1845 10.6068 15.7659 10.6068 15.3293H8.90679C8.90679 15.315 8.91247 15.3013 8.92258 15.2912L10.1247 16.4932ZM10.6068 15.3293C10.6068 14.8927 10.4334 14.474 10.1247 14.1653L8.92258 15.3674C8.91247 15.3573 8.90679 15.3436 8.90679 15.3293H10.6068ZM10.1247 14.1653C9.81596 13.8566 9.39728 13.6832 8.96071 13.6832V15.3832C8.94641 15.3832 8.9327 15.3775 8.92258 15.3674L10.1247 14.1653ZM8.96071 13.6832C8.52415 13.6832 8.10546 13.8566 7.79677 14.1653L8.99885 15.3674C8.98873 15.3775 8.97502 15.3832 8.96071 15.3832V13.6832ZM7.79677 14.1653C7.48807 14.474 7.31464 14.8927 7.31464 15.3293H9.01464C9.01464 15.3436 9.00896 15.3573 8.99885 15.3674L7.79677 14.1653ZM7.31464 15.3293C7.31464 15.7659 7.48807 16.1845 7.79677 16.4932L8.99885 15.2912C9.00896 15.3013 9.01464 15.315 9.01464 15.3293H7.31464ZM7.79677 16.4932C8.10546 16.8019 8.52415 16.9754 8.96071 16.9754V15.2754C8.97502 15.2754 8.98873 15.281 8.99885 15.2912L7.79677 16.4932Z"
                                    fill="#44A561" />
                            </svg>
                        </div>
                        <div class="actions__content--item-text">
                            Reativar
                        </div>
                    </div>
                    <div v-else class="actions__content--item" @click="deactivateUser(value)">
                        <div class="actions__content--item-icon red-bg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23"
                                fill="none">
                                <path
                                    d="M1 10.5529H0.15H1ZM2.59214 21.6979V22.5479V21.6979ZM15.3293 21.6979V22.5479V21.6979ZM16.9214 10.5529H17.7714H16.9214ZM13.6832 8.96071C13.6832 9.43016 14.0638 9.81071 14.5332 9.81071C15.0027 9.81071 15.3832 9.43016 15.3832 8.96071H13.6832ZM8.96071 1V0.15V1ZM3.38821 6.5725H2.53821H3.38821ZM2.53821 8.96071C2.53821 9.43016 2.91877 9.81071 3.38821 9.81071C3.85766 9.81071 4.23821 9.43016 4.23821 8.96071H2.53821ZM9.75679 15.3293H10.6068H9.75679ZM8.96071 14.5332V13.6832V14.5332ZM15.3293 8.11071H2.59214V9.81071H15.3293V8.11071ZM2.59214 8.11071C1.94445 8.11071 1.32328 8.36801 0.865287 8.826L2.06737 10.0281C2.20655 9.8889 2.39531 9.81071 2.59214 9.81071V8.11071ZM0.865287 8.826C0.407297 9.28399 0.15 9.90516 0.15 10.5529H1.85C1.85 10.356 1.92819 10.1673 2.06737 10.0281L0.865287 8.826ZM0.15 10.5529V20.1057H1.85V10.5529H0.15ZM0.15 20.1057C0.15 20.7534 0.407296 21.3746 0.865287 21.8326L2.06737 20.6305C1.92819 20.4913 1.85 20.3025 1.85 20.1057H0.15ZM0.865287 21.8326C1.32328 22.2906 1.94445 22.5479 2.59214 22.5479V20.8479C2.39531 20.8479 2.20655 20.7697 2.06737 20.6305L0.865287 21.8326ZM2.59214 22.5479H15.3293V20.8479H2.59214V22.5479ZM15.3293 22.5479C15.977 22.5479 16.5982 22.2906 17.0561 21.8326L15.8541 20.6305C15.7149 20.7697 15.5261 20.8479 15.3293 20.8479V22.5479ZM17.0561 21.8326C17.5141 21.3746 17.7714 20.7534 17.7714 20.1057H16.0714C16.0714 20.3025 15.9932 20.4913 15.8541 20.6305L17.0561 21.8326ZM17.7714 20.1057V10.5529H16.0714V20.1057H17.7714ZM17.7714 10.5529C17.7714 9.90516 17.5141 9.28399 17.0561 8.826L15.8541 10.0281C15.9932 10.1673 16.0714 10.356 16.0714 10.5529H17.7714ZM17.0561 8.826C16.5982 8.36801 15.977 8.11071 15.3293 8.11071V9.81071C15.5261 9.81071 15.7149 9.8889 15.8541 10.0281L17.0561 8.826ZM15.3832 8.96071V6.5725H13.6832V8.96071H15.3832ZM15.3832 6.5725C15.3832 4.86915 14.7066 3.23556 13.5021 2.03111L12.3 3.23319C13.1857 4.11883 13.6832 5.32001 13.6832 6.5725H15.3832ZM13.5021 2.03111C12.2977 0.826654 10.6641 0.15 8.96071 0.15V1.85C10.2132 1.85 11.4144 2.34755 12.3 3.23319L13.5021 2.03111ZM8.96071 0.15C7.25736 0.15 5.62377 0.826654 4.41932 2.03111L5.6214 3.23319C6.50704 2.34755 7.70823 1.85 8.96071 1.85V0.15ZM4.41932 2.03111C3.21487 3.23556 2.53821 4.86915 2.53821 6.5725H4.23821C4.23821 5.32001 4.73576 4.11883 5.6214 3.23319L4.41932 2.03111ZM2.53821 6.5725V8.96071H4.23821V6.5725H2.53821ZM8.96071 16.9754C9.39728 16.9754 9.81596 16.8019 10.1247 16.4932L8.92258 15.2912C8.9327 15.281 8.94641 15.2754 8.96071 15.2754V16.9754ZM10.1247 16.4932C10.4334 16.1845 10.6068 15.7659 10.6068 15.3293H8.90679C8.90679 15.315 8.91247 15.3013 8.92258 15.2912L10.1247 16.4932ZM10.6068 15.3293C10.6068 14.8927 10.4334 14.474 10.1247 14.1653L8.92258 15.3674C8.91247 15.3573 8.90679 15.3436 8.90679 15.3293H10.6068ZM10.1247 14.1653C9.81596 13.8566 9.39728 13.6832 8.96071 13.6832V15.3832C8.94641 15.3832 8.9327 15.3775 8.92258 15.3674L10.1247 14.1653ZM8.96071 13.6832C8.52415 13.6832 8.10546 13.8566 7.79677 14.1653L8.99885 15.3674C8.98873 15.3775 8.97502 15.3832 8.96071 15.3832V13.6832ZM7.79677 14.1653C7.48807 14.474 7.31464 14.8927 7.31464 15.3293H9.01464C9.01464 15.3436 9.00896 15.3573 8.99885 15.3674L7.79677 14.1653ZM7.31464 15.3293C7.31464 15.7659 7.48807 16.1845 7.79677 16.4932L8.99885 15.2912C9.00896 15.3013 9.01464 15.315 9.01464 15.3293H7.31464ZM7.79677 16.4932C8.10546 16.8019 8.52415 16.9754 8.96071 16.9754V15.2754C8.97502 15.2754 8.98873 15.281 8.99885 15.2912L7.79677 16.4932Z"
                                    fill="#FF5F5F" />
                            </svg>
                        </div>
                        <div class="actions__content--item-text red-color">
                            Suspender
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
</template>

<script>
import Vue from 'vue'
import Money from '@/src/mixins/money'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import UserService from '@services/resources/UserService'


const service = UserService.build()


export default {
    name: 'AnalysisTableSell',
    components: { NewProgressBar },
    mixins: [Money],
    data: {
        return: {
            loading: false
        }
    },
    props: {
        data: {
            type: Object,
            required: false
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        sellerScore(){
            return this.data && this.data.seller && this.data.seller.score && this.data.seller.score.total_score ? this.data.seller.score.total_score : 0;
        },
        sellerId(){
            return this.data && this.data.seller && this.data.seller.id ? '#' + this.data.seller.id : '---';
        },
        value() {
          return this.data && this.data.seller && this.data.seller.is_disabled === 1 ? 1 : 0;
        },

        dynamicColor() {
            if(this.data && this.data.seller && this.data.seller.score && this.data.seller.score.total_score){
                const score = this.data.seller.score.total_score;
                if (score > 800) {
                    return '#28A745';
                } else if (score > 600) {
                    return '#8EBE23';
                } else if (score > 450) {
                    return '#FFD700';
                } else if (score > 250) {
                    return '#FFA500';
                } else {
                    return '#FC183B';
                }
            }
            return '#FC183B';
        }

    },
    methods: {
        sellerDetails(){
            this.$emit('sellerDetails')
        },
        deactivateUser(value){
            const disabled = value === 1 ? true: false;
        Vue.swal({
            title: 'Usuário',
            text: `Tem certeza que deseja ${disabled  ? 'Reativar' : 'Desativar'} esse usuário?`,
            type: 'error',
            showCancelButton: true,
            confirmButtonText: `${disabled ? 'Reativar' : 'Desativar'}`,
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
        }).then((result) => {
                if (result.value) {
                    this.loading = true
                
                    service
                    .update('disabled/' + this.data.seller.id)
                    .then(() => {
                    this.data.seller.is_disabled = disabled ? 0 : 1;
                    this.$bvToast.toast(`Usuário ${disabled ? 'Reativado': 'Desativado'} com sucesso`, {
                        title: 'Usuário',
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: true,
                    })

                    this.$emit('close')
                    this.$bvModal.hide('modal-edit-user')
                    })
                    .catch((err) => {
                    console.error(err)
                    this.$bvToast.toast('Não foi possível desativar o usuário', {
                        title: 'Usuário',
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: true,
                    })
                    })
                    .finally(() => {
                    this.loading = false
                    })
                }else{
                    this.data.seller.is_disabled = value;
                }
            })
        }, 
    }
};
</script>

<style scoped lang="scss">
.scoreData {
    width: 100%;
    height: auto;

    &__sell {
        width: 100%;
        height: auto;
        border-radius: 15px;
        border: 1px solid #E5E5E5;

        &--header {
            width: 100%;
            padding: 20px;
            display: flex;

            &-title {
                color: #141414;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                display: flex;
                justify-content: flex-start;
                width: 60%;
            }

            &-value {
                color: #F5B17C;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                display: flex;
                justify-content: flex-end;
                width: 40%;
            }
        }

        &--content {
            width: 100%;
            padding: 0px 20px;
        }

        &--footer {
            width: 100%;
            padding: 20px 20px;

            &-title {
                color: #B1B1B1;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            &-value {
                color: #B1B1B1;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
        }
    }

    &__seller {
        width: 100%;
        height: auto;
        border-radius: 15px;
        border: 1px solid #E5E5E5;
    }
}

.actions {
    margin-top: 10px;
    width: 100%;
    border: 1px solid #E5E5E5;
    border-radius: 15px;
    padding: 20px 4px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #44A561;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 20px;
        }
    }

    &__content {
        height: auto;
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        margin: 0;
        list-style: none;

        &--item {
            width: 33%;
            height: auto;
            margin: 20px auto 0px auto;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            display: flex;
            cursor: pointer;

            &-icon {
                display: flex;
                background-color: #44A5611A;
                width: 55px;
                height: 55px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
            }

            &-text {
                color: #44A561;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin: 10px 0px 0px 0px;
                text-align: center;
                width: 100%;
            }
        }

        // action__content--item-icon
    }
}

.red-bg {
    background: rgba(255, 95, 95, 0.10);
}

.red-color {
    color: #FF5F5F;
}
</style>